export default __webpack_public_path__ + "static/media/tube-spinner3.ab82a0bf.svg";